<template>
  <v-row no-gutters>
    <v-col>
      <v-menu
        v-model="menuData"
        :disabled="disabled || item.readonly"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="computedDateFormatted"
            :label="item.label"
            :rules="rulesValidation"
            readonly
            v-bind="attrs"
            v-on="on"
            clearable
            @click:clear="item.value = ''"
          ></v-text-field>
        </template>
        <v-date-picker :value="parsedDate" no-title scrollable @input="menuData = false" @change="onChange"></v-date-picker>
      </v-menu>
    </v-col>
    <v-col>
      <v-menu
        ref="menu"
        v-model="menuOra"
        :close-on-content-click="false"
        :close-on-click="false"
        :nudge-right="40"
        :return-value.sync="ora"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="computedTimeFormatted"
            v-model="ora"
            label="Orario"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker v-if="menuOra" v-model="ora" format="24hr" full-width  @click:minute="onChangeOra"></v-time-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
  import { validazioni } from '@/mixins/validazioni.js'
  import moment from 'moment'
  
  export default {
    name: 'eldata',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      disabled: { type: Boolean, default: false }
    },
    data: (vm) => ({
      menuData: false,
      menuOra: false,
      data: null,
      ora: null
    }),
    mounted() {
      if (this.item && this.item.value) {
        this.ora = moment(this.item.value).format('HH:mm')
      }
      if (this.item && this.item.default) {
        this.ora = this.item.default
      }
    },
    computed: {
      computedDateFormatted() {
        return this.item && this.item.value ? this.formatDate(this.item.value) : ''
      },
      parsedDate() {
        return this.item && this.item.value ? moment(this.item.value).format('YYYY-MM-DD') : ''
      },
      computedTimeFormatted() {
        return moment(this.item.value).format('HH:mm')
      }
    },
    methods: {
      formatDate (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      async onChange(value) {
        console.log('data onchange', value)
        let data = `${value} ${this.ora || ''}`.trim()
        this.item.value = moment(data).toDate() // .format()
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: this.item.value })
      },
      async onChangeOra(value) {
        this.$refs.menu.save(this.ora)
        let data = `${this.parsedDate} ${this.ora}`
        this.item.value = moment(data).toDate()
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: this.item.value })
      },
      // aggiungere :allowed-minutes="allowedStep"   nel componente
      allowedStep: m => m % 5 === 0      
    }
  }
</script>
